<template>
	<div class="">
		<Header></Header>
		<h4>{{oonfooData.title}}</h4>
		<div class="lines"></div>
		<div class="infomsg">
			<span>
				<img src="../assets/fenzhan/biao.png" alt="">
			</span>

			<span>
				{{oonfooData.ctime | dateFormat}}
			</span>
			<span>
				<img src="../assets/fenzhan/dizhi.png" alt="">
			</span>
			<span>{{oonfooData.siteName}}</span>
			<span>
				<img src="../assets/fenzhan/yj.png" alt="">
			</span>
			<span>
			{{oonfooData.browseNum}}
			</span>
		</div>
		<!--内容-->
		<div class="countent1">
			<p v-html='oonfooData.content'></p>
		</div>
		<Fotter></Fotter>
	</div>
</template>
<script>
	import Header from "./Header.vue";
	import Fotter from "./Fotter.vue";
	import __Config from '../api/config';	
	export default {
		name: 'Fenzhan',
		components: {
			Header,
			Fotter
		},
		data() {
			return {
               id:null,
			   oonfooData:[],
			}

		},
		methods: {
           getDetailinfo(){
			     this.$toast.loading({
					duration: 0,  
					mask: true,
					message: '加载中...'
				});
					    var that = this;
						this.$axios.get(__Config.api.getinfo,{
							params: {
								id:this.id,
								siteCode:this.$store.state.treeData.code,
								siteId:this.$store.state.treeData.id
							}
						})
						.then(function (res) {
								that.$toast.clear();
							that.oonfooData= res.data.data.articleManager;
						})
						.catch(function (err) {
								that.$toast.clear();
							console.log(err);
						});
				},
		},
	    created(){
			 this.id = this.$route.query.id
			this.getDetailinfo();
		}
	}
</script>

<style scoped>
	@import url("../assets/css/articleDetail.css");
	.countent1{
		width: 98%;
		height: 100%;
		margin: 0 auto;
	
	}
	.countent1 p{
		text-align: center;
		font-size: 13px;
	}
	.countent1 img{
		width: 98%;
		height: 100%;
	}

</style>



// WEBPACK FOOTER //
// src/components/ZixunDetail.vue